import { render, staticRenderFns } from "./anchorLabel.vue?vue&type=template&id=66b3396b&scoped=true"
import script from "./anchorLabel.vue?vue&type=script&lang=js"
export * from "./anchorLabel.vue?vue&type=script&lang=js"
import style0 from "./anchorLabel.vue?vue&type=style&index=0&id=66b3396b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b3396b",
  null
  
)

export default component.exports